import { render, staticRenderFns } from "./ProjectsPage.vue?vue&type=template&id=63f75b4a&scoped=true&"
import script from "./ProjectsPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPage.vue?vue&type=style&index=0&id=63f75b4a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f75b4a",
  null
  
)

export default component.exports